(function () {
  const CUSTOM_ROOT_SELECTOR = '[data-custom-selleasy-bundle]';
  const DEBUG_KEY = 'customSelleasyBundleDebug';
  const WIDGET_SELECTOR = [
    '.lb-upsell-widget',
    '.lb-upsell-widget-bl',
    '.lb-widget',
    '[class*="lb-upsell"]',
    '[id*="lb-upsell"]',
    '[class*="selleasy" i]',
    '[id*="selleasy" i]',
    '[data-app*="selleasy" i]',
    '[data-widget*="fbt" i]',
    '[data-widget*="bundle" i]',
  ].join(',');

  const MONEY_DECIMALS = {
    BHD: 3,
    BIF: 0,
    BYR: 0,
    CLF: 4,
    CLP: 0,
    DJF: 0,
    GNF: 0,
    IQD: 3,
    ISK: 0,
    JOD: 3,
    JPY: 0,
    KMF: 0,
    KRW: 0,
    KWD: 3,
    LYD: 3,
    MRO: 5,
    OMR: 3,
    PYG: 0,
    RWF: 0,
    TND: 3,
    UGX: 0,
    UYI: 0,
    UYW: 4,
    VND: 0,
    VUV: 0,
    XAF: 0,
    XOF: 0,
    XPF: 0,
  };
  const state = {
    widget: null,
    nativeRoot: null,
    ui: null,
    products: [],
    nativeButton: null,
    campaignTitle: 'Bundle & Save',
    discountPercent: null,
    discountSource: 'fallback',
    metadata: {},
    rendered: false,
    adding: false,
  };
  const CART_REDIRECT_GUARD_BUFFER_MS = 2200;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  function init() {
    const main = document.querySelector("main[data-template^='product']");
    if (!(main instanceof HTMLElement)) return;

    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(tryRender);
    });

    observer.observe(main, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'disabled', 'value'],
    });

    tryRender();
  }

  function tryRender() {
    if (document.querySelector(CUSTOM_ROOT_SELECTOR)) {
      state.rendered = true;
      return;
    }

    const widget = findSelleasyWidget();
    debug('FBT List widget found or not', Boolean(widget), widget);
    if (!(widget instanceof HTMLElement)) return;

    const extraction = extractBundle(widget);
    if (!extraction || extraction.products.length < 2) {
      debug('FBT List extraction not ready', extraction);
      return;
    }

    state.widget = widget;
    state.nativeRoot = getNativeRoot(widget);
    state.products = extraction.products.slice(0, 2);
    state.nativeButton = extraction.nativeButton;
    state.campaignTitle = extraction.campaignTitle || 'Bundle & Save';
    state.discountPercent = extraction.discountPercent;
    state.discountSource = extraction.discountSource;
    state.metadata = extraction.metadata;

    const ui = buildBundleUi();
    const host = state.nativeRoot.parentElement || widget.parentElement;
    if (!(host instanceof HTMLElement)) return;

    host.insertBefore(ui, state.nativeRoot);
    state.nativeRoot.classList.add('custom-selleasy-bundle-native-hidden');
    state.ui = ui;
    state.rendered = true;

    debug('extracted products/variants', state.products);
    debug('campaign title detected', state.campaignTitle);
    state.products.forEach((product) => {
      const variant = getSelectedVariant(product);
      const price = getVariantPrice(variant);
      debug('raw price source for product', {
        product: product.title,
        variantId: variant.id,
        raw: price.raw,
        source: price.source,
      });
      debug('selected variant ID', variant.id);
      debug('selected variant image URL', getVariantImage(product, variant));
    });
    debug('selected variant IDs', getSelectedVariantIds());
    debug('variant image URLs', state.products.map((product) => product.variants.map((variant) => variant.image).filter(Boolean)));
    debug('extracted discount data', {
      discountPercent: state.discountPercent,
      discountSource: state.discountSource,
      totals: calculateTotals(),
    });
    debug('discount percentage source', state.discountSource);
    debug('required Selleasy metadata', state.metadata);
    debug('native Selleasy button found', Boolean(state.nativeButton), state.nativeButton);

    enrichProductsWithShopifyJson().then(() => {
      refreshProductCards();
      refreshTotals(state.ui);
    });
  }

  function findSelleasyWidget() {
    const main = document.querySelector("main[data-template^='product']");
    if (!(main instanceof HTMLElement)) return null;

    const candidates = Array.from(main.querySelectorAll(WIDGET_SELECTOR)).filter((node) => {
      if (!(node instanceof HTMLElement)) return false;
      if (node.closest(CUSTOM_ROOT_SELECTOR)) return false;
      if (node.matches('script, style, link, template')) return false;
      if (!hasBundleSignal(node)) return false;
      return node.querySelector('button, a, select, input, img, [data-variant-id]');
    });

    candidates.sort((a, b) => scoreWidget(b) - scoreWidget(a));
    return candidates[0] || null;
  }

  function hasBundleSignal(node) {
    const haystack = [
      node.id,
      node.className,
      node.getAttribute('data-widget'),
      node.getAttribute('data-app'),
      node.getAttribute('data-block-handle'),
      node.textContent,
    ]
      .join(' ')
      .toLowerCase();

    return /(selleasy|lb-upsell|lb-widget|fbt|bundle|frequently|bought together|pillowcase|add bundle)/i.test(haystack);
  }

  function scoreWidget(node) {
    const text = node.textContent.toLowerCase();
    let score = 0;
    if (/fbt list|frequently|bought together/i.test(text)) score += 10;
    if (/add.*bundle|bundle.*cart/i.test(text)) score += 8;
    if (/selleasy|lb-upsell|lb-widget/i.test(`${node.id} ${node.className}`)) score += 6;
    score += node.querySelectorAll('select, input[name*="variant" i], [data-variant-id]').length;
    score += Math.min(node.querySelectorAll('img').length, 4);
    return score;
  }

  function getNativeRoot(widget) {
    return (
      widget.closest('.shopify-block, [data-shopify-editor-block], [data-block-id], .orthocloud-social__app') ||
      widget
    );
  }

  function extractBundle(widget) {
    const nativeButton = findNativeButton(widget);
    const payloads = extractPayloads(widget);
    const payloadProducts = extractPayloadProducts(payloads);
    const productNodes = findProductNodes(widget, nativeButton);
    const products = productNodes
      .map((node, index) => extractProduct(node, index, findMatchingPayloadProduct(node, payloadProducts) || payloadProducts[index]))
      .filter(Boolean);
    const uniqueProducts = dedupeProducts(products);
    const totals = extractWidgetTotals(widget);
    const discount = extractDiscountPercent(widget, payloads, totals);

    return {
      products: uniqueProducts,
      nativeButton,
      campaignTitle: extractCampaignTitle(widget, payloads),
      discountPercent: discount.percent,
      discountSource: discount.source,
      metadata: extractSelleasyMetadata(widget),
    };
  }

  function extractSelleasyMetadata(widget) {
    return {
      widgetDataset: getPlainDataset(widget),
      rootDataset: getPlainDataset(getNativeRoot(widget)),
      forms: Array.from(widget.querySelectorAll('form')).map((form) => ({
        action: form.getAttribute('action') || '',
        method: form.getAttribute('method') || '',
        dataset: getPlainDataset(form),
      })),
      hiddenInputs: Array.from(widget.querySelectorAll('input[type="hidden"]')).map((input) => ({
        name: input.getAttribute('name') || '',
        value: input.getAttribute('value') || input.value || '',
        dataset: getPlainDataset(input),
      })),
    };
  }

  function findMatchingPayloadProduct(node, payloadProducts) {
    const title = normalizeOptionText(extractTitle(node));
    const handle = extractProductHandle(node);

    return payloadProducts.find((product) => {
      if (handle && product.handle && handle === product.handle) return true;
      if (title && normalizeOptionText(product.title) === title) return true;
      return false;
    });
  }

  function findNativeButton(widget) {
    const controls = Array.from(widget.querySelectorAll('button, [role="button"], input[type="button"], input[type="submit"], a'));
    return (
      controls.find((control) => /add.*bundle|bundle.*cart|add selected|add.*cart/i.test(getControlText(control))) ||
      controls.find((control) => /add/i.test(getControlText(control))) ||
      null
    );
  }

  function findProductNodes(widget, nativeButton) {
    const controls = getVariantControls(widget);
    const nodes = controls
      .map((control) => getProductNode(control, widget, nativeButton))
      .filter((node) => node instanceof HTMLElement);

    const deduped = [];
    nodes.forEach((node) => {
      if (deduped.some((item) => item === node || item.contains(node) || node.contains(item))) return;
      deduped.push(node);
    });

    if (deduped.length >= 2) return deduped.slice(0, 2);

    const visualRows = Array.from(widget.querySelectorAll('li, article, [class*="product" i], [class*="item" i], [class*="offer" i]'))
      .filter((node) => node instanceof HTMLElement)
      .filter((node) => node !== widget && !node.contains(nativeButton))
      .filter((node) => node.querySelector('img') && /\d/.test(node.textContent));

    return dedupeElements(visualRows).slice(0, 2);
  }

  function getVariantControls(root) {
    const selector = [
      'select',
      'input[name="id"]',
      'input[name*="variant" i]',
      'input[value][data-variant-id]',
      '[data-variant-id]',
    ].join(',');

    return Array.from(root.querySelectorAll(selector)).filter((control) => {
      if (!(control instanceof HTMLElement)) return false;
      if (control.closest(CUSTOM_ROOT_SELECTOR)) return false;
      if (control.matches('button, a')) return false;
      const value = getControlVariantId(control);
      if (!value && control instanceof HTMLSelectElement && !control.options.length) return false;
      return true;
    });
  }

  function getProductNode(control, widget, nativeButton) {
    let node = control instanceof HTMLElement ? control : null;
    let best = null;

    while (node && node !== widget) {
      if (node.contains(nativeButton)) break;
      const hasImage = Boolean(node.querySelector('img'));
      const hasText = node.textContent.trim().length > 0;
      const variantCount = getVariantControls(node).length;

      if (hasText && (hasImage || variantCount > 0)) {
        best = node;
        if (hasImage && variantCount <= 2) break;
      }

      node = node.parentElement;
    }

    return best || control.closest('li, article, div');
  }

  function extractProduct(node, index, payloadProduct) {
    if (!(node instanceof HTMLElement)) return null;

    const nativeControls = getVariantControls(node);
    const title = extractTitle(node) || payloadProduct?.title || `Bundle product ${index + 1}`;
    const handle = extractProductHandle(node) || payloadProduct?.handle || '';
    const productImage = extractImage(node) || payloadProduct?.image || '';
    const price = extractDomPrice(node) || extractDatasetPrice(node) || emptyPrice('none');
    const priceText = price.formatted;
    const priceCents = price.cents;
    const variants = mergePayloadVariants(
      extractVariants(node, nativeControls, productImage, price),
      payloadProduct?.variants || []
    );
    const selectedVariantId = extractSelectedVariantId(nativeControls, variants);

    if (!variants.length) {
      variants.push({
        id: selectedVariantId || `bundle-product-${index + 1}`,
        title: 'Default',
        image: productImage,
        price,
        priceCents,
        priceText,
      });
    }

    return {
      node,
      nativeControls,
      title,
      handle,
      image: productImage,
      variantImageMap: buildVariantImageMap({
        image: productImage,
        variants,
      }),
      price,
      priceText,
      priceCents,
      selectedVariantId: selectedVariantId || variants[0].id,
      variants,
    };
  }

  function extractTitle(node) {
    const titleNode = node.querySelector('[data-product-title], [class*="title" i], h1, h2, h3, h4, a[href*="/products/"]');
    const title = titleNode instanceof HTMLElement ? titleNode.textContent.trim() : '';
    if (title && !looksLikePrice(title) && title.length < 90) return title;

    const lines = node.textContent
      .split(/\n+/)
      .map((line) => line.trim())
      .filter(Boolean)
      .filter((line) => !looksLikePrice(line))
      .filter((line) => !/add|bundle|save|variant|select|quantity/i.test(line));

    return lines.find((line) => line.length > 2 && line.length < 90) || '';
  }

  function extractImage(node) {
    const image = node.querySelector('img');
    if (!(image instanceof HTMLImageElement)) return '';

    return normalizeImageUrl(
      image.currentSrc ||
        image.src ||
        image.getAttribute('data-src') ||
        image.getAttribute('data-original') ||
        image.getAttribute('srcset')?.split(',')?.[0]?.trim()?.split(' ')?.[0] ||
        ''
    );
  }

  function extractProductHandle(node) {
    const link = node.querySelector('a[href*="/products/"]');
    if (!(link instanceof HTMLAnchorElement)) return '';

    try {
      const url = new URL(link.href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      const match = link.getAttribute('href')?.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    }
  }

  function extractHandleFromUrl(url) {
    if (!url) return '';

    try {
      const parsedUrl = new URL(url, window.location.origin);
      const match = parsedUrl.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      const match = String(url).match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    }
  }

  function extractPriceText(node) {
    const candidates = Array.from(node.querySelectorAll('[class*="price" i], [data-price], [data-variant-price], [data-money], span, strong'))
      .filter((item) => {
        if (!(item instanceof HTMLElement)) return false;
        const text = item.textContent.trim().replace(/\s+/g, ' ');
        if (!text || text.length > 48) return false;
        return looksLikePrice(text);
      })
      .sort((a, b) => priceNodeScore(b) - priceNodeScore(a));

    const priceNode = candidates.find((item) => {
      if (!(item instanceof HTMLElement)) return false;
      return !Array.from(item.children).some((child) => child instanceof HTMLElement && looksLikePrice(child.textContent.trim()));
    });

    return priceNode instanceof HTMLElement ? priceNode.textContent.trim().replace(/\s+/g, ' ') : '';
  }

  function priceNodeScore(node) {
    const className = String(node.className || '').toLowerCase();
    let score = 0;
    if (className.includes('price')) score += 4;
    if (node.hasAttribute('data-price') || node.hasAttribute('data-variant-price')) score += 3;
    if (node.children.length === 0) score += 2;
    if (node.textContent.trim().length < 24) score += 1;
    return score;
  }

  function extractDomPrice(node) {
    const text = extractPriceText(node);
    if (!text) return null;
    return normalizePriceValue(text, {
      source: 'dom',
      preserveFormatted: true,
    });
  }

  function extractDatasetPrice(node) {
    const data = firstDatasetEntry(node, ['price', 'variantPrice', 'money', 'amount', 'priceCents', 'price_cents']);
    if (!data) return null;

    return normalizePriceValue(data.value, {
      source: `dataset:${data.key}`,
      key: data.key,
    });
  }

  function extractVariants(node, nativeControls, productImage, fallbackPrice) {
    const select = nativeControls.find((control) => control instanceof HTMLSelectElement);
    if (select instanceof HTMLSelectElement) {
      return Array.from(select.options)
        .filter((option) => option.value)
        .map((option) => {
          const optionText = option.textContent.trim();
          const datasetPrice = firstDatasetEntry(option, ['price', 'variantPrice', 'money', 'amount', 'priceCents', 'price_cents']);
          const formattedPrice = firstDatasetValue(option, ['priceText', 'formattedPrice']);
          const optionPriceText = extractMoneyText(optionText);
          const price =
            (formattedPrice &&
              normalizePriceValue(formattedPrice, {
                source: 'option:formattedPrice',
                preserveFormatted: true,
              })) ||
            (datasetPrice &&
              normalizePriceValue(datasetPrice.value, {
                source: `option:${datasetPrice.key}`,
                key: datasetPrice.key,
              })) ||
            (optionPriceText &&
              normalizePriceValue(optionPriceText, {
                source: 'option:text',
                preserveFormatted: true,
              })) ||
            fallbackPrice;

          return {
            id: option.value,
            title: stripMoneyFromText(optionText) || option.value,
            image: normalizeImageUrl(
              firstDatasetValue(option, ['image', 'imageUrl', 'featuredImage', 'variantImage']) ||
                extractVariantImageFromDom(node, option.value, optionText) ||
                productImage
            ),
            optionValues: extractOptionValues(option, optionText),
            price,
            priceCents: price?.cents ?? null,
            priceText: price?.formatted || '',
          };
        });
    }

    const groupedRadios = nativeControls.filter((control) => control instanceof HTMLInputElement && /radio|checkbox|hidden/i.test(control.type));
    const variants = groupedRadios
      .map((input) => {
        const id = getControlVariantId(input);
        if (!id) return null;

        const label = getLabelText(input) || input.getAttribute('aria-label') || input.value;
        const container = input.closest('label, li, div') || node;
        const datasetPrice = firstDatasetEntry(input, ['price', 'variantPrice', 'money', 'amount', 'priceCents', 'price_cents']);
        const containerPrice = extractDomPrice(container) || extractDatasetPrice(container);
        const price =
          (datasetPrice &&
            normalizePriceValue(datasetPrice.value, {
              source: `input:${datasetPrice.key}`,
              key: datasetPrice.key,
            })) ||
          containerPrice ||
          fallbackPrice;

        return {
          id,
          title: stripMoneyFromText(label) || label,
          image: normalizeImageUrl(firstDatasetValue(input, ['image', 'imageUrl', 'featuredImage', 'variantImage']) || extractImage(container) || productImage),
          optionValues: extractOptionValues(input, label),
          price,
          priceCents: price?.cents ?? null,
          priceText: price?.formatted || '',
        };
      })
      .filter(Boolean);

    return dedupeVariants(variants);
  }

  function extractVariantImageFromDom(root, variantId, optionTitle) {
    const escapedVariantId = window.CSS?.escape ? window.CSS.escape(String(variantId)) : String(variantId).replace(/"/g, '\\"');
    const exactNode = root.querySelector(
      `[data-variant-id="${escapedVariantId}"] img, img[data-variant-id="${escapedVariantId}"], [value="${escapedVariantId}"] img`
    );
    if (exactNode instanceof HTMLImageElement) return normalizeImageUrl(extractImageFromElement(exactNode));

    const normalizedTitle = normalizeOptionText(optionTitle);
    if (!normalizedTitle) return '';

    const titleNode = Array.from(root.querySelectorAll('label, li, div, button, [role="option"]')).find((item) => {
      if (!(item instanceof HTMLElement) || !item.querySelector('img')) return false;
      return normalizeOptionText(item.textContent).includes(normalizedTitle);
    });

    return titleNode instanceof HTMLElement ? extractImage(titleNode) : '';
  }

  function extractOptionValues(node, fallbackText) {
    const rawValues = [
      firstDatasetValue(node, ['option', 'option1', 'option2', 'option3', 'value', 'variantTitle']),
      node instanceof HTMLOptionElement ? node.label : '',
      fallbackText,
    ];

    return rawValues
      .flatMap((value) => String(value || '').split(/\s*\/\s*|\s*,\s*/))
      .map((value) => stripMoneyFromText(value).trim())
      .filter(Boolean);
  }

  function extractImageFromElement(image) {
    if (!(image instanceof HTMLImageElement)) return '';
    return (
      image.currentSrc ||
      image.src ||
      image.getAttribute('data-src') ||
      image.getAttribute('data-original') ||
      image.getAttribute('srcset')?.split(',')?.[0]?.trim()?.split(' ')?.[0] ||
      ''
    );
  }

  function extractPayloads(widget) {
    return Array.from(widget.querySelectorAll('script[type="application/json"], script:not([src])'))
      .map((script) => script.textContent.trim())
      .filter((text) => text.startsWith('{') || text.startsWith('['))
      .map(parseJson)
      .filter(Boolean);
  }

  function extractPayloadProducts(payloads) {
    const products = [];
    payloads.forEach((payload) => {
      collectPayloadProducts(payload, products);
    });

    return dedupePayloadProducts(products);
  }

  function collectPayloadProducts(value, products) {
    if (!value || typeof value !== 'object') return;

    if (Array.isArray(value)) {
      value.forEach((item) => collectPayloadProducts(item, products));
      return;
    }

    const variants = Array.isArray(value.variants) ? value.variants : Array.isArray(value.productVariants) ? value.productVariants : null;
    const title = value.title || value.productTitle || value.name;
    const handle =
      value.handle ||
      value.productHandle ||
      value.product_handle ||
      extractHandleFromUrl(value.url || value.productUrl || value.product_url || '');

    if (variants && variants.length && title) {
      products.push({
        title,
        handle,
        image: payloadImage(value),
        variants: variants
          .map((variant) => {
            const price = normalizePayloadPrice(variant);
            return {
              id: String(variant.id || variant.variant_id || variant.variantId || ''),
              title: variant.title || variant.name || variant.option1 || variant.public_title || 'Default',
              image: payloadImage(variant) || payloadImage(value),
              optionValues: extractPayloadOptionValues(variant),
              price,
              priceCents: price?.cents ?? null,
              priceText: price?.formatted || '',
            };
          })
          .filter((variant) => variant.id),
      });
    }

    Object.keys(value).forEach((key) => {
      const child = value[key];
      if (child && typeof child === 'object') collectPayloadProducts(child, products);
    });
  }

  function payloadImage(value) {
    if (!value || typeof value !== 'object') return '';

    const image =
      value.image ||
      value.imageUrl ||
      value.image_url ||
      value.featuredImage ||
      value.featured_image ||
      value.variantImage ||
      value.variant_image ||
      value.featuredMedia ||
      value.featured_media ||
      value.media;

    if (typeof image === 'string') return normalizeImageUrl(image);
    if (image && typeof image === 'object') {
      return normalizeImageUrl(
        image.src ||
          image.url ||
          image.originalSrc ||
          image.transformedSrc ||
          image.preview_image?.src ||
          image.previewImage?.src ||
          image.image?.src ||
          ''
      );
    }

    return '';
  }

  function extractPayloadOptionValues(variant) {
    return [
      variant.option1,
      variant.option2,
      variant.option3,
      variant.option,
      variant.value,
      variant.color,
      variant.colour,
      variant.title,
      variant.name,
      variant.public_title,
    ]
      .filter(Boolean)
      .flatMap((value) => String(value).split(/\s*\/\s*|\s*,\s*/))
      .map((value) => stripMoneyFromText(value).trim())
      .filter(Boolean);
  }

  function mergePayloadVariants(domVariants, payloadVariants) {
    if (!payloadVariants.length) return domVariants;

    const payloadById = new Map(payloadVariants.map((variant) => [String(variant.id), variant]));
    const payloadByTitle = new Map(
      payloadVariants
        .map((variant) => [normalizeOptionText(variant.title), variant])
        .filter(([title]) => title)
    );

    const merged = domVariants.map((variant) => {
      const payload = payloadById.get(String(variant.id)) || payloadByTitle.get(normalizeOptionText(variant.title));
      if (!payload) return variant;

      const image = payload.image || variant.image;
      const price = mergePrice(variant.price, payload.price);

      return {
        ...variant,
        title: variant.title || payload.title,
        image,
        price,
        priceCents: price?.cents ?? null,
        priceText: price?.formatted || '',
      };
    });

    payloadVariants.forEach((variant) => {
      if (merged.some((item) => String(item.id) === String(variant.id))) return;
      merged.push(variant);
    });

    return dedupeVariants(merged);
  }

  function dedupePayloadProducts(products) {
    const seen = new Set();
    return products.filter((product) => {
      const key = product.title || product.variants.map((variant) => variant.id).join(',');
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function parseJson(text) {
    try {
      return JSON.parse(text);
    } catch (error) {
      return null;
    }
  }

  function findPayloadNumber(payloads, keys) {
    const value = findPayloadValue(payloads, keys, (item) => {
      if (typeof item === 'number') return Number.isFinite(item);
      if (typeof item === 'string') return /-?\d+(?:\.\d+)?\s*%?/.test(item.trim());
      return false;
    });

    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
      const match = value.match(/-?\d+(?:\.\d+)?/);
      return match ? Number(match[0]) : null;
    }
    return null;
  }

  function findPayloadValue(value, keys, predicate) {
    if (!value || typeof value !== 'object') return null;

    if (Array.isArray(value)) {
      for (const item of value) {
        const match = findPayloadValue(item, keys, predicate);
        if (match != null) return match;
      }
      return null;
    }

    for (const key of Object.keys(value)) {
      const item = value[key];
      if (keys.includes(key) && predicate(item)) return item;
    }

    for (const key of Object.keys(value)) {
      const item = value[key];
      if (!item || typeof item !== 'object') continue;
      const match = findPayloadValue(item, keys, predicate);
      if (match != null) return match;
    }

    return null;
  }

  function extractSelectedVariantId(nativeControls, variants) {
    const select = nativeControls.find((control) => control instanceof HTMLSelectElement);
    if (select instanceof HTMLSelectElement && select.value) return select.value;

    const checked = nativeControls.find((control) => control instanceof HTMLInputElement && control.checked);
    const checkedId = getControlVariantId(checked);
    if (checkedId) return checkedId;

    const first = nativeControls.map(getControlVariantId).find(Boolean);
    return first || variants[0]?.id || '';
  }

  function extractCampaignTitle(widget, payloads) {
    const titleKeys = [
      'campaignTitle',
      'campaign_title',
      'offerTitle',
      'offer_title',
      'widgetTitle',
      'widget_title',
      'title',
      'name',
    ];
    const payloadTitle = findPayloadValue(
      payloads,
      titleKeys,
      (item) => typeof item === 'string' && isUsableCampaignTitle(item)
    );

    if (isUsableCampaignTitle(payloadTitle)) return payloadTitle.trim();

    const titleNode = Array.from(
      widget.querySelectorAll('[class*="title" i], [class*="heading" i], [data-title], h1, h2, h3, h4')
    ).find((node) => node instanceof HTMLElement && isUsableCampaignTitle(node.textContent));

    if (titleNode instanceof HTMLElement) return titleNode.textContent.trim().replace(/\s+/g, ' ');

    return 'Bundle & Save';
  }

  function isUsableCampaignTitle(value) {
    const title = String(value || '').trim();
    if (!title || title.length < 3 || title.length > 120) return false;
    if (looksLikePrice(title)) return false;
    if (/^(default|true|false|null|undefined)$/i.test(title)) return false;
    return /bundle|save|bought|together|offer|deal|add|pair|complete|fbt/i.test(title);
  }

  function buildBundleUi() {
    const root = document.createElement('section');
    root.className = 'custom-selleasy-bundle';
    root.setAttribute('data-custom-selleasy-bundle', '');
    root.setAttribute('aria-label', 'Bundle and save');

    const card = document.createElement('div');
    card.className = 'custom-selleasy-bundle__card';

    const header = document.createElement('div');
    header.className = 'custom-selleasy-bundle__header';
    header.innerHTML = `
      <span class="custom-selleasy-bundle__badge">BUNDLE &amp; SAVE</span>
      <h2 class="custom-selleasy-bundle__heading"></h2>
    `;
    const heading = header.querySelector('.custom-selleasy-bundle__heading');
    if (heading) heading.textContent = state.campaignTitle || 'Bundle & Save';

    const products = document.createElement('div');
    products.className = 'custom-selleasy-bundle__products';
    products.append(buildProductCard(state.products[0], 0));
    products.append(buildPlusIcon());
    products.append(buildProductCard(state.products[1], 1));

    const totals = buildTotalsPanel();
    card.append(header, products, totals);
    root.append(card);
    refreshTotals(root);
    return root;
  }

  function buildProductCard(product, index) {
    const selectedVariant = getSelectedVariant(product);
    const article = document.createElement('article');
    article.className = 'custom-selleasy-bundle__product';
    article.dataset.productIndex = String(index);

    const media = document.createElement('div');
    media.className = 'custom-selleasy-bundle__media';

    const image = document.createElement('img');
    image.className = 'custom-selleasy-bundle__image';
    image.loading = 'lazy';
    image.alt = buildVariantImageAlt(product, selectedVariant);
    updateBundleCardImage(image, getVariantImage(product, selectedVariant) || product.image || '', image.alt);
    media.append(image);

    const body = document.createElement('div');
    body.className = 'custom-selleasy-bundle__product-body';

    const title = document.createElement('h3');
    title.className = 'custom-selleasy-bundle__title';
    title.textContent = product.title;

    const controls = document.createElement('div');
    controls.className = 'custom-selleasy-bundle__controls';

    const select = document.createElement('select');
    select.className = 'custom-selleasy-bundle__select';
    select.setAttribute('aria-label', `${product.title} variant`);
    product.variants.forEach((variant) => {
      const option = document.createElement('option');
      option.value = variant.id;
      option.textContent = variant.title;
      option.selected = variant.id === product.selectedVariantId;
      option.dataset.variantId = variant.id;
      option.dataset.variantTitle = variant.title || '';
      option.dataset.variantImage = getVariantImage(product, variant) || '';
      select.append(option);
    });

    const price = document.createElement('div');
    price.className = 'custom-selleasy-bundle__price';
    price.textContent = formatVariantPrice(selectedVariant);

    select.addEventListener('change', () => {
      product.selectedVariantId = select.value;
      syncProductToNative(product);
      const nextVariant = getSelectedVariant(product);
      const selectedOption = select.selectedOptions[0];
      const nextImage = getVariantImage(product, nextVariant, selectedOption) || image.currentSrc || image.src || product.image || '';
      const updated = updateBundleCardImage(image, nextImage, buildVariantImageAlt(product, nextVariant));
      price.textContent = formatVariantPrice(nextVariant);
      refreshTotals(state.ui);
      debug('custom-to-native variant sync', {
        product: product.title,
        selectedVariantId: product.selectedVariantId,
      });
      debug('variant image update', {
        product: product.title,
        selectedVariantId: product.selectedVariantId,
        selectedVariantTitle: nextVariant.title,
        selectedVariantImageUrl: nextImage,
        succeeded: updated,
        finalImgSrc: image.currentSrc || image.src,
      });
    });

    controls.append(select, price);
    body.append(title, controls);
    article.append(media, body);
    return article;
  }

  function buildPlusIcon() {
    const plus = document.createElement('div');
    plus.className = 'custom-selleasy-bundle__plus';
    plus.setAttribute('aria-hidden', 'true');
    plus.innerHTML = '<svg viewBox="0 0 16 16" focusable="false"><path d="M7 1h2v6h6v2H9v6H7V9H1V7h6V1Z" fill="currentColor"/></svg>';
    return plus;
  }

  function buildTotalsPanel() {
    const panel = document.createElement('div');
    panel.className = 'custom-selleasy-bundle__totals';
    const discountLabel = state.discountPercent != null ? `${formatPercent(state.discountPercent)} off` : 'bundle offer';
    panel.innerHTML = `
      <div class="custom-selleasy-bundle__total-copy">
        <p class="custom-selleasy-bundle__line">Original total <strong data-bundle-original-inline></strong></p>
        <p class="custom-selleasy-bundle__line">Bundle total <strong data-bundle-discounted-inline></strong></p>
        <p class="custom-selleasy-bundle__line custom-selleasy-bundle__save">You save <strong data-bundle-savings></strong> (${discountLabel})</p>
      </div>
      <div class="custom-selleasy-bundle__checkout">
        <div class="custom-selleasy-bundle__price-stack">
          <span class="custom-selleasy-bundle__compare" data-bundle-original></span>
          <span class="custom-selleasy-bundle__final" data-bundle-discounted></span>
        </div>
        <button class="custom-selleasy-bundle__button" type="button" data-bundle-add>Add bundle to cart</button>
      </div>
    `;

    const button = panel.querySelector('[data-bundle-add]');
    button?.addEventListener('click', addBundleToCart);
    return panel;
  }

  function refreshTotals(root) {
    if (!(root instanceof HTMLElement)) return;
    const totals = calculateTotals();

    setText(root, '[data-bundle-original-inline]', totals.originalText);
    setText(root, '[data-bundle-discounted-inline]', totals.discountedText);
    setText(root, '[data-bundle-savings]', totals.savingsText);
    setText(root, '[data-bundle-original]', totals.originalText);
    setText(root, '[data-bundle-discounted]', totals.discountedText);
  }

  function calculateTotals() {
    const selectedVariants = state.products.map(getSelectedVariant);
    const centsValues = selectedVariants.map((variant) => getVariantPrice(variant).cents);
    const canCalculate = centsValues.every((value) => Number.isFinite(value));
    const originalCents = canCalculate ? centsValues.reduce((sum, value) => sum + value, 0) : null;
    const discountPercent = getEffectiveDiscountPercent();
    const discountedCents =
      originalCents != null && discountPercent != null ? Math.round(originalCents * (1 - discountPercent / 100)) : null;
    const savingsCents =
      originalCents != null && discountedCents != null ? Math.max(originalCents - discountedCents, 0) : null;
    const formattedPrices = selectedVariants.map(formatVariantPrice).filter(Boolean);

    return {
      originalCents,
      discountedCents,
      savingsCents,
      originalText: originalCents != null ? formatMoney(originalCents) : formattedPrices.join(' + '),
      discountedText: discountedCents != null ? formatMoney(discountedCents) : formattedPrices.join(' + '),
      savingsText: savingsCents != null ? formatMoney(savingsCents) : discountPercent != null ? formatPercent(discountPercent) : '',
    };
  }

  async function addBundleToCart(event) {
    event.preventDefault();

    if (state.adding) return;

    const button = event.currentTarget;
    const nativeButton = findNativeButton(state.widget) || state.nativeButton;
    const nativeForm = getNativeSelleasyForm(nativeButton);
    const guard = createNativeCartRedirectGuard(nativeButton, nativeForm);

    state.adding = true;
    guard.install();

    if (button instanceof HTMLButtonElement) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    try {
      state.products.forEach(syncProductToNative);
      debug('custom-to-native variant sync', getSelectedVariantIds());
      debug('native Selleasy button found', Boolean(nativeButton), nativeButton);
      debug('native Selleasy form found', Boolean(nativeForm), nativeForm);

      const cartBeforeAdd = await fetchCart();
      const nativeResult = await runSelleasyAdd(nativeButton, nativeForm, cartBeforeAdd, guard);
      const cartAfterAdd = nativeResult?.cart || (await waitForCartChange(cartBeforeAdd));

      if (!cartAfterAdd) {
        throw new Error('Bundle add did not update the cart.');
      }

      const sections = await fetchCartSections();
      dispatchBundleCartUpdate(cartAfterAdd, sections, cartBeforeAdd);
      await openCartDrawerForBundleAdd();
      window.setTimeout(logCartDebug, 800);
    } catch (error) {
      console.error('[custom Selleasy bundle] Add bundle to cart failed', error);
    } finally {
      if (button instanceof HTMLButtonElement) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
      window.setTimeout(() => {
        guard.cleanup();
        state.adding = false;
      }, CART_REDIRECT_GUARD_BUFFER_MS);
    }
  }

  async function runSelleasyAdd(nativeButton, nativeForm, cartBeforeAdd, guard) {
    const selectedVariantIds = getSelectedVariantIds();
    let attemptedSelectedVariantAdd = false;
    const nativeWidgetResult = await runNativeSelleasyWidgetAdd(cartBeforeAdd, selectedVariantIds);

    if (nativeWidgetResult) {
      return nativeWidgetResult;
    }

    if (nativeForm instanceof HTMLFormElement) {
      debug('submitting native Selleasy form with AJAX first', summarizeFormData(nativeForm, nativeButton));
      try {
        await submitNativeSelleasyFormAjax(nativeForm, nativeButton);
      } catch (error) {
        debug('AJAX native form submit failed; checking cart before guarded fallback', error);
      }

      const cartAfterAjax = await waitForCartChange(cartBeforeAdd);
      if (cartAfterAjax) {
        const missingVariantIds = getMissingSelectedVariantIds(cartBeforeAdd, cartAfterAjax, selectedVariantIds);
        if (!missingVariantIds.length) {
          return {
            cart: cartAfterAjax,
            source: 'ajax-form',
          };
        }

        debug('AJAX native form updated cart but missed selected bundle variants; adding missing variants', missingVariantIds);
        attemptedSelectedVariantAdd = true;
        const completedCart = await addSelectedBundleVariantsAjax(missingVariantIds, nativeForm, cartAfterAjax);
        if (completedCart) {
          return {
            cart: completedCart,
            source: 'ajax-form-plus-selected-variants',
          };
        }
        return null;
      }

      debug('AJAX native form submit completed without selected bundle cart delta; adding selected variants directly');
      attemptedSelectedVariantAdd = true;
      const cartAfterSelectedVariantAdd = await addSelectedBundleVariantsAjax(selectedVariantIds, nativeForm, cartBeforeAdd);
      if (cartAfterSelectedVariantAdd) {
        return {
          cart: cartAfterSelectedVariantAdd,
          source: 'selected-variants',
        };
      }
    }

    if (!attemptedSelectedVariantAdd && nativeForm instanceof HTMLFormElement) {
      const cartAfterSelectedVariantAdd = await addSelectedBundleVariantsAjax(selectedVariantIds, nativeForm, cartBeforeAdd);
      if (cartAfterSelectedVariantAdd) {
        return {
          cart: cartAfterSelectedVariantAdd,
          source: 'selected-variants',
        };
      }
    }

    debug('skipping native Selleasy click fallback to avoid app-forced cart redirect');

    if (guard.interceptedSubmitPromise) {
      await guard.interceptedSubmitPromise;
      return {
        cart: await waitForCartChange(cartBeforeAdd),
        source: 'intercepted-submit',
      };
    }

    const cartAfterNativeClick = await waitForCartChange(cartBeforeAdd, 12, 250);
    if (cartAfterNativeClick) {
      return {
        cart: cartAfterNativeClick,
        source: 'native-click',
      };
    }

    return null;
  }

  async function runNativeSelleasyWidgetAdd(cartBeforeAdd, selectedVariantIds) {
    const nativeWidget = getNativeSelleasyWidgetElement();
    const widgetHandler = window.lbHandlers?.widget;

    if (!(nativeWidget instanceof HTMLElement) || typeof nativeWidget.getSelectedProducts !== 'function') {
      return null;
    }

    if (!widgetHandler || typeof widgetHandler.processWidgets !== 'function') {
      debug('native Selleasy widget found, but processWidgets is unavailable');
      return null;
    }

    debug('triggering native Selleasy widget add flow', {
      offer: nativeWidget.getAttribute('offer') || '',
      widget: nativeWidget.getAttribute('widget') || '',
      selectedVariantIds,
    });

    try {
      await widgetHandler.processWidgets([{ widgetSrcElement: nativeWidget }]);
    } catch (error) {
      debug('native Selleasy widget add flow failed', error);
      return null;
    }

    const cartAfterNativeWidget = await waitForCartChange(cartBeforeAdd, 24, 250);
    if (!cartAfterNativeWidget) return null;

    const missingVariantIds = getMissingSelectedVariantIds(cartBeforeAdd, cartAfterNativeWidget, selectedVariantIds);
    if (missingVariantIds.length) {
      debug('native Selleasy widget add flow updated cart but missed selected variants', missingVariantIds);
      return null;
    }

    return {
      cart: cartAfterNativeWidget,
      source: 'native-widget',
    };
  }

  function createNativeCartRedirectGuard(nativeButton, nativeForm) {
    const root = state.nativeRoot || state.widget;
    let interceptedSubmitPromise = null;
    let submitHandled = false;
    const originalSubmit = HTMLFormElement.prototype.submit;
    const originalRequestSubmit = HTMLFormElement.prototype.requestSubmit;
    const originalSetTimeout = window.setTimeout;
    const originalSetInterval = window.setInterval;
    const originalWindowOpen = window.open;
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;
    let patchedSubmit = null;
    let patchedRequestSubmit = null;
    let patchedSetTimeout = null;
    let patchedSetInterval = null;
    let patchedWindowOpen = null;
    let patchedPushState = null;
    let patchedReplaceState = null;
    let restoreLocationAssign = null;
    let restoreLocationReplace = null;
    let navigationTarget = null;

    const isInsideNativeBundle = (target) => {
      if (!(target instanceof Node)) return false;
      if (root instanceof HTMLElement && root.contains(target)) return true;
      if (nativeButton instanceof HTMLElement && nativeButton.contains(target)) return true;
      if (nativeForm instanceof HTMLFormElement && nativeForm.contains(target)) return true;
      return false;
    };

    const handleClick = (event) => {
      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (link instanceof HTMLAnchorElement && isCartNavigationUrl(link.href)) {
        debugRedirectGuard('blocked cart anchor click', {
          href: link.href,
          insideNativeBundle: isInsideNativeBundle(event.target),
          target: describeNode(event.target),
        });
        event.preventDefault();
        event.stopImmediatePropagation();
      } else if (link instanceof HTMLAnchorElement && isInsideNativeBundle(event.target)) {
        debugRedirectGuard('native widget anchor click observed', {
          href: link.href,
          target: describeNode(event.target),
        });
      }
    };

    const interceptSubmit = (form) => {
      if (submitHandled) return;

      submitHandled = true;
      debugRedirectGuard('intercepted form submit for AJAX cart add', {
        action: form.getAttribute('action') || '',
        method: form.getAttribute('method') || '',
      });
      interceptedSubmitPromise = delay(0).then(() => submitNativeSelleasyFormAjax(form, nativeButton));
    };

    const handleSubmit = (event) => {
      if (!(event.target instanceof HTMLFormElement)) return;

      const action = event.target.getAttribute('action') || '';
      const shouldBlock = isInsideNativeBundle(event.target) || isCartNavigationUrl(action);
      if (!shouldBlock) return;

      debugRedirectGuard('blocked native form submit navigation', {
        action,
        method: event.target.getAttribute('method') || '',
        insideNativeBundle: isInsideNativeBundle(event.target),
      });
      event.preventDefault();
      interceptSubmit(event.target);
    };

    const handleNavigation = (event) => {
      if (!isCartNavigationUrl(event.destination?.url)) return;

      debugRedirectGuard('blocked navigation API cart redirect', {
        url: event.destination.url,
        canIntercept: Boolean(event.canIntercept),
        cancelable: Boolean(event.cancelable),
      });

      event.preventDefault();
    };

    return {
      get interceptedSubmitPromise() {
        return interceptedSubmitPromise;
      },
      install() {
        debugRedirectGuard('installing temporary cart redirect guard');
        document.addEventListener('click', handleClick, true);
        window.addEventListener('click', handleClick, true);
        document.addEventListener('submit', handleSubmit, true);
        window.addEventListener('submit', handleSubmit, true);
        navigationTarget = 'navigation' in window ? window.navigation : null;
        navigationTarget?.addEventListener?.('navigate', handleNavigation, true);

        patchedSubmit = function submit() {
          const action = this instanceof HTMLFormElement ? this.getAttribute('action') || '' : '';
          if (isInsideNativeBundle(this) || isCartNavigationUrl(action)) {
            debugRedirectGuard('blocked HTMLFormElement.prototype.submit navigation', {
              action,
              insideNativeBundle: isInsideNativeBundle(this),
            });
            interceptSubmit(this);
            return;
          }

          return originalSubmit.apply(this, arguments);
        };
        HTMLFormElement.prototype.submit = patchedSubmit;

        if (typeof originalRequestSubmit === 'function') {
          patchedRequestSubmit = function requestSubmit() {
            const action = this instanceof HTMLFormElement ? this.getAttribute('action') || '' : '';
            if (isInsideNativeBundle(this) || isCartNavigationUrl(action)) {
              debugRedirectGuard('blocked HTMLFormElement.prototype.requestSubmit navigation', {
                action,
                insideNativeBundle: isInsideNativeBundle(this),
              });
              interceptSubmit(this);
              return;
            }

            return originalRequestSubmit.apply(this, arguments);
          };
          HTMLFormElement.prototype.requestSubmit = patchedRequestSubmit;
        }

        patchedSetTimeout = function setTimeout(callback, timeout) {
          if (typeof callback === 'function' && looksLikeDelayedCartRedirect(callback)) {
            debugRedirectGuard('blocked suspicious delayed cart redirect timeout', {
              delay: timeout,
              callback: summarizeCallback(callback),
            });
            return originalSetTimeout(() => {}, timeout);
          }

          if (typeof callback === 'string' && looksLikeCartRedirectScript(callback)) {
            debugRedirectGuard('blocked suspicious delayed cart redirect timeout string', {
              delay: timeout,
              callback,
            });
            return originalSetTimeout(() => {}, timeout);
          }

          return originalSetTimeout.apply(this, arguments);
        };
        window.setTimeout = patchedSetTimeout;

        patchedSetInterval = function setInterval(callback, timeout) {
          if (typeof callback === 'function' && looksLikeDelayedCartRedirect(callback)) {
            debugRedirectGuard('blocked suspicious delayed cart redirect interval', {
              delay: timeout,
              callback: summarizeCallback(callback),
            });
            return originalSetInterval(() => {}, timeout);
          }

          if (typeof callback === 'string' && looksLikeCartRedirectScript(callback)) {
            debugRedirectGuard('blocked suspicious delayed cart redirect interval string', {
              delay: timeout,
              callback,
            });
            return originalSetInterval(() => {}, timeout);
          }

          return originalSetInterval.apply(this, arguments);
        };
        window.setInterval = patchedSetInterval;

        patchedWindowOpen = function open(url) {
          if (isCartNavigationUrl(url)) {
            debugRedirectGuard('blocked window.open to cart', { url });
            return null;
          }

          return originalWindowOpen.apply(this, arguments);
        };
        window.open = patchedWindowOpen;

        patchedPushState = function pushState(stateValue, title, url) {
          if (isCartNavigationUrl(url)) {
            debugRedirectGuard('blocked history.pushState to cart', { url });
            return;
          }

          return originalPushState.apply(this, arguments);
        };
        window.history.pushState = patchedPushState;

        patchedReplaceState = function replaceState(stateValue, title, url) {
          if (isCartNavigationUrl(url)) {
            debugRedirectGuard('blocked history.replaceState to cart', { url });
            return;
          }

          return originalReplaceState.apply(this, arguments);
        };
        window.history.replaceState = patchedReplaceState;

        restoreLocationAssign = patchLocationMethod('assign');
        restoreLocationReplace = patchLocationMethod('replace');
      },
      cleanup() {
        debugRedirectGuard('cleaning up temporary cart redirect guard');
        document.removeEventListener('click', handleClick, true);
        window.removeEventListener('click', handleClick, true);
        document.removeEventListener('submit', handleSubmit, true);
        window.removeEventListener('submit', handleSubmit, true);
        navigationTarget?.removeEventListener?.('navigate', handleNavigation, true);

        if (patchedSubmit && HTMLFormElement.prototype.submit === patchedSubmit) {
          HTMLFormElement.prototype.submit = originalSubmit;
        }

        if (patchedRequestSubmit && HTMLFormElement.prototype.requestSubmit === patchedRequestSubmit) {
          HTMLFormElement.prototype.requestSubmit = originalRequestSubmit;
        }

        if (patchedSetTimeout && window.setTimeout === patchedSetTimeout) {
          window.setTimeout = originalSetTimeout;
        }

        if (patchedSetInterval && window.setInterval === patchedSetInterval) {
          window.setInterval = originalSetInterval;
        }

        if (patchedWindowOpen && window.open === patchedWindowOpen) {
          window.open = originalWindowOpen;
        }

        if (patchedPushState && window.history.pushState === patchedPushState) {
          window.history.pushState = originalPushState;
        }

        if (patchedReplaceState && window.history.replaceState === patchedReplaceState) {
          window.history.replaceState = originalReplaceState;
        }

        restoreLocationAssign?.();
        restoreLocationReplace?.();
      },
    };
  }

  function getNativeSelleasyForm(nativeButton) {
    if (nativeButton instanceof HTMLElement) {
      const closestForm = nativeButton.closest('form');
      if (closestForm instanceof HTMLFormElement) return closestForm;
    }

    const root = state.nativeRoot || state.widget;
    if (!(root instanceof HTMLElement)) return null;

    return (
      root.querySelector('form[action*="/cart/add"], form[action*="/cart"], form') ||
      state.widget?.querySelector('form[action*="/cart/add"], form[action*="/cart"], form') ||
      null
    );
  }

  function getNativeSelleasyWidgetElement() {
    const root = state.nativeRoot || state.widget;
    const selectors = [
      'lb-upsell-widget[offer]',
      'lb-upsell-widget[widget]',
      '[offer][widget]',
    ].join(',');

    if (root instanceof HTMLElement) {
      if (root.matches(selectors)) return root;
      const widget = root.querySelector(selectors);
      if (widget instanceof HTMLElement) return widget;
    }

    if (state.widget instanceof HTMLElement) {
      if (state.widget.matches(selectors)) return state.widget;
      const widget = state.widget.querySelector(selectors);
      if (widget instanceof HTMLElement) return widget;
    }

    return null;
  }

  async function submitNativeSelleasyFormAjax(form, submitter) {
    const formData = new FormData(form);

    if (submitter instanceof HTMLElement) {
      const name = submitter.getAttribute('name');
      const value = submitter.getAttribute('value');
      if (name && value != null && !formData.has(name)) {
        formData.append(name, value);
      }
    }

    const response = await fetch(getNativeCartAddUrl(form), {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      redirect: 'manual',
      headers: {
        Accept: 'application/json',
      },
    });

    if (response.type === 'opaqueredirect' || response.status === 0) return null;

    const text = await response.text();
    const data = parseJson(text);

    if (!response.ok || data?.status) {
      throw new Error(data?.description || data?.message || response.statusText || 'Native Selleasy cart add failed.');
    }

    return data;
  }

  async function addSelectedBundleVariantsAjax(variantIds, nativeForm, previousCart) {
    const selectedVariantIds = variantIds.map((id) => String(id || '').trim()).filter(Boolean);
    if (!selectedVariantIds.length) return null;

    const payload = {
      items: buildSelectedBundleCartItems(selectedVariantIds, nativeForm),
    };

    if (!payload.items.length) return null;

    debug('adding selected bundle variants with AJAX', payload);

    const response = await fetch(getSelleasyCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    const text = await response.text();
    const data = parseJson(text);

    if (!response.ok || data?.status) {
      throw new Error(data?.description || data?.message || response.statusText || 'Selected bundle cart add failed.');
    }

    const cartAfterAdd = await waitForCartChange(previousCart);
    if (!cartAfterAdd) return null;

    const missingVariantIds = getMissingSelectedVariantIds(previousCart, cartAfterAdd, selectedVariantIds);
    if (missingVariantIds.length) {
      debug('selected bundle AJAX add did not include every expected variant', missingVariantIds);
      return null;
    }

    return cartAfterAdd;
  }

  function buildSelectedBundleCartItems(variantIds, nativeForm) {
    const formData = nativeForm instanceof HTMLFormElement ? new FormData(nativeForm) : null;
    const formContext = formData ? extractCartAddFormContext(formData) : emptyCartAddFormContext();

    return variantIds
      .map((variantId, index) => buildSelectedBundleCartItem(variantId, index, formContext))
      .filter((item) => item.id);
  }

  function buildSelectedBundleCartItem(variantId, index, formContext) {
    const matchingFormItem =
      formContext.items.find((item) => String(item.id) === String(variantId)) ||
      formContext.items[index] ||
      null;
    const properties = {
      ...getSelleasyLineItemProperties(),
      ...formContext.properties,
      ...(matchingFormItem?.properties || {}),
    };
    const item = {
      id: toShopifyVariantId(variantId),
      quantity: Math.max(Number(matchingFormItem?.quantity || formContext.quantity || 1), 1),
    };
    const sellingPlan = matchingFormItem?.selling_plan || formContext.selling_plan;

    if (sellingPlan) item.selling_plan = sellingPlan;
    if (Object.keys(properties).length) item.properties = properties;

    return item;
  }

  function getSelleasyCartAddUrl() {
    const url = new URL(window.Theme?.routes?.cart_add_url || '/cart/add.js', window.location.origin);
    const lineItemProperties = getSelleasyLineItemProperties();

    if (lineItemProperties['_lb-product']) {
      url.searchParams.set('src', 'selleasy');
    }

    return url.toString();
  }

  function getSelleasyLineItemProperties() {
    const nativeWidget = getNativeSelleasyWidgetElement();
    const offerId = nativeWidget?.getAttribute?.('offer') || '';
    const trigger = nativeWidget?.lbPayload?.widget?.triggers?.[0] || nativeWidget?.lbPayload?.widget?.triggerItem || null;
    const triggerId = trigger?.lbId || trigger?.product_id || trigger?.productId || trigger?.id || nativeWidget?.getAttribute?.('lb-trigger-product-id') || '';

    if (!triggerId || !offerId) return {};

    return {
      '_lb-product': `${triggerId}#${offerId}`,
    };
  }

  function extractCartAddFormContext(formData) {
    const context = emptyCartAddFormContext();

    formData.forEach((value, name) => {
      if (typeof value !== 'string') return;

      const itemMatch = name.match(/^items\[(\d+)\]\[([^\]]+)\](?:\[([^\]]+)\])?$/);
      if (itemMatch) {
        const item = getIndexedCartItem(context.items, Number(itemMatch[1]));
        const key = itemMatch[2];
        const nestedKey = itemMatch[3];

        if (key === 'properties' && nestedKey) {
          item.properties[nestedKey] = value;
          return;
        }

        item[key] = value;
        return;
      }

      const propertyMatch = name.match(/^properties\[(.+)\]$/);
      if (propertyMatch) {
        context.properties[propertyMatch[1]] = value;
        return;
      }

      if (name === 'quantity') {
        context.quantity = value;
        return;
      }

      if (name === 'selling_plan') {
        context.selling_plan = value;
      }
    });

    context.items = context.items.filter((item) => item.id);
    return context;
  }

  function emptyCartAddFormContext() {
    return {
      items: [],
      properties: {},
      quantity: 1,
      selling_plan: '',
    };
  }

  function getIndexedCartItem(items, index) {
    if (!items[index]) {
      items[index] = {
        properties: {},
      };
    }

    return items[index];
  }

  function toShopifyVariantId(variantId) {
    const numericId = Number(variantId);
    return Number.isSafeInteger(numericId) ? numericId : variantId;
  }

  function getNativeCartAddUrl(form) {
    const fallback = window.Theme?.routes?.cart_add_url || '/cart/add.js';
    const rawAction = form.getAttribute('action') || fallback;

    try {
      const url = new URL(rawAction, window.location.origin);

      if (/\/cart\/add(?:\.js)?\/?$/i.test(url.pathname)) {
        url.pathname = url.pathname.replace(/\/cart\/add(?:\.js)?\/?$/i, '/cart/add.js');
        return url.toString();
      }

      if (/\/cart\/?$/i.test(url.pathname)) {
        return new URL(fallback, window.location.origin).toString();
      }
    } catch (error) {
      return fallback;
    }

    return fallback;
  }

  function isCartNavigationUrl(value) {
    if (value == null || value === '') return false;

    try {
      const url = new URL(value, window.location.origin);
      return isCartPath(url.pathname);
    } catch (error) {
      const path = String(value || '').split(/[?#]/)[0];
      return isCartPath(path);
    }
  }

  function isCartPath(pathname) {
    const normalizedPath = String(pathname || '')
      .replace(/^https?:\/\/[^/]+/i, '')
      .split(/[?#]/)[0]
      .replace(/\/+$/, '');

    if (!normalizedPath) return false;

    const segments = normalizedPath.split('/').filter(Boolean);
    return segments[segments.length - 1]?.toLowerCase() === 'cart';
  }

  function patchLocationMethod(methodName) {
    const originalMethod = window.location?.[methodName];
    if (typeof originalMethod !== 'function') return null;

    const patchedMethod = function patchedLocationMethod(url) {
      if (isCartNavigationUrl(url)) {
        debugRedirectGuard(`blocked window.location.${methodName} to cart`, { url });
        return;
      }

      return originalMethod.apply(window.location, arguments);
    };

    const restoreAttempts = [];

    try {
      window.location[methodName] = patchedMethod;
      if (window.location[methodName] === patchedMethod) {
        restoreAttempts.push(() => {
          window.location[methodName] = originalMethod;
        });
        debugRedirectGuard(`patched window.location.${methodName}`);
      }
    } catch (error) {
      debugRedirectGuard(`unable to assign window.location.${methodName}`, error);
    }

    try {
      const locationPrototype = Object.getPrototypeOf(window.location);
      const descriptor = locationPrototype ? Object.getOwnPropertyDescriptor(locationPrototype, methodName) : null;

      if (descriptor?.configurable) {
        const patchedDescriptor = 'value' in descriptor
          ? {
              ...descriptor,
              value: patchedMethod,
            }
          : {
              configurable: descriptor.configurable,
              enumerable: descriptor.enumerable,
              writable: true,
              value: patchedMethod,
            };

        Object.defineProperty(locationPrototype, methodName, patchedDescriptor);
        restoreAttempts.push(() => {
          Object.defineProperty(locationPrototype, methodName, descriptor);
        });
        debugRedirectGuard(`patched Location.prototype.${methodName}`);
      }
    } catch (error) {
      debugRedirectGuard(`unable to patch Location.prototype.${methodName}`, error);
    }

    if (!restoreAttempts.length) {
      debugRedirectGuard(`window.location.${methodName} could not be patched by this browser`);
      return null;
    }

    return () => {
      restoreAttempts.reverse().forEach((restore) => {
        try {
          restore();
        } catch (error) {
          debugRedirectGuard(`failed restoring window.location.${methodName}`, error);
        }
      });
    };
  }

  function looksLikeDelayedCartRedirect(callback) {
    return looksLikeCartRedirectScript(callback.toString());
  }

  function looksLikeCartRedirectScript(script) {
    const source = String(script || '');
    if (!/cart/i.test(source)) return false;
    return /(?:location|href|assign|replace|pushState|replaceState|window\.open|document\.location)/i.test(source);
  }

  function summarizeCallback(callback) {
    return callback.toString().replace(/\s+/g, ' ').slice(0, 240);
  }

  function summarizeFormData(form, submitter) {
    try {
      const formData = new FormData(form);
      if (submitter instanceof HTMLElement) {
        const name = submitter.getAttribute('name');
        const value = submitter.getAttribute('value');
        if (name && value != null && !formData.has(name)) formData.append(name, value);
      }

      return Array.from(formData.entries()).map(([name, value]) => ({
        name,
        value: typeof value === 'string' ? value : value.name || '[file]',
      }));
    } catch (error) {
      return { error: String(error) };
    }
  }

  function describeNode(node) {
    if (!(node instanceof Element)) return String(node);

    const parts = [node.tagName.toLowerCase()];
    if (node.id) parts.push(`#${node.id}`);
    if (node.className && typeof node.className === 'string') {
      parts.push(
        `.${node.className
          .trim()
          .split(/\s+/)
          .slice(0, 4)
          .join('.')}`
      );
    }

    return parts.join('');
  }

  function debugRedirectGuard(label, value) {
    debug(`redirect guard: ${label}`, value || '');
  }

  async function waitForCartChange(previousCart, attempts = 16, delayMs = 250) {
    for (let attempt = 0; attempt < attempts; attempt += 1) {
      if (attempt > 0) await delay(delayMs);

      const cart = await fetchCart();
      if (cart && hasCartChanged(previousCart, cart)) return cart;
    }

    return null;
  }

  function hasCartChanged(previousCart, nextCart) {
    if (!nextCart) return false;
    if (!previousCart) return true;
    if (previousCart.item_count !== nextCart.item_count) return true;
    if (previousCart.total_price !== nextCart.total_price) return true;

    const previousKeys = Array.isArray(previousCart.items)
      ? previousCart.items.map((item) => `${item.key}:${item.quantity}`).join('|')
      : '';
    const nextKeys = Array.isArray(nextCart.items)
      ? nextCart.items.map((item) => `${item.key}:${item.quantity}`).join('|')
      : '';

    return previousKeys !== nextKeys;
  }

  function getMissingSelectedVariantIds(previousCart, nextCart, selectedVariantIds) {
    const previousCounts = getCartVariantCounts(previousCart);
    const nextCounts = getCartVariantCounts(nextCart);
    const desiredCounts = selectedVariantIds.reduce((counts, variantId) => {
      const key = String(variantId);
      counts.set(key, (counts.get(key) || 0) + 1);
      return counts;
    }, new Map());
    const missingVariantIds = [];

    desiredCounts.forEach((desiredCount, variantId) => {
      const previousCount = previousCounts.get(variantId) || 0;
      const nextCount = nextCounts.get(variantId) || 0;
      const addedCount = Math.max(nextCount - previousCount, 0);
      const missingCount = Math.max(desiredCount - addedCount, 0);

      for (let index = 0; index < missingCount; index += 1) {
        missingVariantIds.push(variantId);
      }
    });

    return missingVariantIds;
  }

  function getCartVariantCounts(cart) {
    const counts = new Map();
    const items = Array.isArray(cart?.items) ? cart.items : [];

    items.forEach((item) => {
      const variantId = String(item.variant_id || item.id || '');
      if (!variantId) return;
      counts.set(variantId, (counts.get(variantId) || 0) + Number(item.quantity || 0));
    });

    return counts;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => (response.ok ? response.json() : null))
      .catch((error) => {
        debug('cart.js fetch failed', error);
        return null;
      });
  }

  async function fetchCartSections() {
    const sectionIds = getCartSectionIds();
    if (!sectionIds.length) return {};

    const cartUrl = new URL(window.Theme?.routes?.cart_url || '/cart', window.location.origin);
    cartUrl.searchParams.set('sections', sectionIds.join(','));

    try {
      const response = await fetch(cartUrl.toString(), {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) return {};

      return (await response.json()) || {};
    } catch (error) {
      debug('cart sections fetch failed', error);
      return {};
    }
  }

  function getCartSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((component) => component instanceof HTMLElement ? component.dataset.sectionId : '')
      .filter(Boolean)
      .filter((sectionId, index, sectionIds) => sectionIds.indexOf(sectionId) === index);
  }

  function dispatchBundleCartUpdate(cart, sections, previousCart) {
    const itemCountAdded = getCartItemCountDelta(previousCart, cart);

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart || {},
          sourceId: 'custom-selleasy-bundle',
          data: {
            source: 'product-form-component',
            bundleSource: 'custom-selleasy-bundle',
            itemCount: itemCountAdded,
            sections,
          },
        },
      })
    );
  }

  function getCartItemCountDelta(previousCart, nextCart) {
    const previousCount = Number(previousCart?.item_count);
    const nextCount = Number(nextCart?.item_count);

    if (Number.isFinite(previousCount) && Number.isFinite(nextCount)) {
      return Math.max(nextCount - previousCount, 0);
    }

    return state.products.length || 1;
  }

  async function openCartDrawerForBundleAdd() {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (!(cartDrawer instanceof HTMLElement)) return;

    await customElements.whenDefined('cart-drawer-component');

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      cartDrawer.dataset.openSource = 'cart-add';
    }
  }

  function delay(ms) {
    return new Promise((resolve) => window.setTimeout(resolve, ms));
  }

  function syncProductToNative(product) {
    const variantId = String(product.selectedVariantId || '');
    if (!variantId) return;

    const select = product.nativeControls.find((control) => control instanceof HTMLSelectElement);
    if (select instanceof HTMLSelectElement) {
      select.value = variantId;
      dispatchNativeChange(select);
      return;
    }

    const target = product.nativeControls.find((control) => getControlVariantId(control) === variantId);
    if (target instanceof HTMLInputElement) {
      if (target.type === 'radio' || target.type === 'checkbox') {
        target.checked = true;
        target.click();
      } else {
        target.value = variantId;
      }
      dispatchNativeChange(target);
    }
  }

  function logCartDebug() {
    if (!isDebug()) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((cart) => {
        debug('cart.js after add', cart);
        debug(
          'discount applications/allocations',
          cart.items?.map((item) => ({
            id: item.id,
            key: item.key,
            title: item.product_title,
            discounts: item.discounts,
            discount_allocations: item.discount_allocations,
            properties: item.properties,
          }))
        );
      })
      .catch((error) => debug('cart.js after add failed', error));
  }

  function getSelectedVariant(product) {
    return product.variants.find((variant) => variant.id === product.selectedVariantId) || product.variants[0] || {};
  }

  async function enrichProductsWithShopifyJson() {
    await Promise.all(state.products.map(enrichProductWithShopifyJson));
  }

  async function enrichProductWithShopifyJson(product) {
    const handle = product.handle || handleize(product.title);
    if (!handle) return;

    try {
      const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
        credentials: 'same-origin',
      });
      if (!response.ok) return;

      const productJson = await response.json();
      const featuredImage = normalizeImageUrl(productJson.featured_image || productJson.images?.[0] || product.image || '');
      product.image = product.image || featuredImage;

      const shopifyVariants = Array.isArray(productJson.variants) ? productJson.variants : [];
      const byId = new Map(shopifyVariants.map((variant) => [String(variant.id), variant]));
      const byTitle = new Map(
        shopifyVariants
          .map((variant) => [normalizeOptionText(variant.title), variant])
          .filter(([title]) => title)
      );

      product.variants = product.variants.map((variant) => {
        const shopifyVariant = byId.get(String(variant.id)) || byTitle.get(normalizeOptionText(variant.title));
        if (!shopifyVariant) return variant;

        const shopifyImage = normalizeImageUrl(
          shopifyVariant.featured_image?.src ||
            shopifyVariant.featured_image ||
            shopifyVariant.featured_media?.preview_image?.src ||
            shopifyVariant.featured_media?.src ||
            shopifyVariant.image ||
            featuredImage ||
            ''
        );
        const price = mergePrice(
          variant.price,
          normalizePriceValue(shopifyVariant.price, {
            source: 'shopify-product-json:price',
            key: 'priceCents',
          })
        );
        const shopifyOptionValues = [
          shopifyVariant.option1,
          shopifyVariant.option2,
          shopifyVariant.option3,
          shopifyVariant.title,
        ].filter(Boolean);

        return {
          ...variant,
          image: variant.image && variant.image !== product.image ? variant.image : shopifyImage || variant.image,
          optionValues: Array.from(new Set([...(variant.optionValues || []), ...shopifyOptionValues])),
          price,
          priceCents: price?.cents ?? null,
          priceText: price?.formatted || '',
        };
      });
      product.variantImageMap = buildVariantImageMap(product);
    } catch (error) {
      debug('Shopify product JSON image fallback failed', {
        product: product.title,
        handle,
        error,
      });
    }
  }

  function refreshProductCards() {
    if (!(state.ui instanceof HTMLElement)) return;

    state.products.forEach((product, index) => {
      const card = state.ui.querySelector(`[data-product-index="${index}"]`);
      if (!(card instanceof HTMLElement)) return;

      const variant = getSelectedVariant(product);
      const image = card.querySelector('.custom-selleasy-bundle__image');
      const price = card.querySelector('.custom-selleasy-bundle__price');
      const nextImage = getVariantImage(product, variant);

      if (image instanceof HTMLImageElement && nextImage) updateBundleCardImage(image, nextImage, buildVariantImageAlt(product, variant));
      if (price instanceof HTMLElement) price.textContent = formatVariantPrice(variant);
    });
  }

  function getVariantImage(product, variant, selectedOption) {
    const map = product?.variantImageMap || buildVariantImageMap(product);
    const selectedVariantId = String(selectedOption?.dataset?.variantId || selectedOption?.value || variant?.id || '').trim();
    const selectedTitle = selectedOption?.dataset?.variantTitle || selectedOption?.textContent || variant?.title || '';
    const optionValues = variant?.optionValues || [];
    const candidates = [
      selectedVariantId && map.byId.get(selectedVariantId),
      variant?.id && map.byId.get(String(variant.id)),
      selectedTitle && map.byTitle.get(normalizeOptionText(selectedTitle)),
      variant?.title && map.byTitle.get(normalizeOptionText(variant.title)),
      ...optionValues.map((value) => map.byTitle.get(normalizeOptionText(value))),
      variant?.image && {
        image: variant.image,
      },
      selectedOption?.dataset?.variantImage && {
        image: selectedOption.dataset.variantImage,
      },
    ].filter(Boolean);

    const found = candidates.find((entry) => isUsableImageUrl(entry.image));
    return normalizeImageUrl(found?.image || product?.image || '');
  }

  function buildVariantImageMap(product) {
    const map = {
      byId: new Map(),
      byTitle: new Map(),
    };

    if (!product) return map;

    (product.variants || []).forEach((variant) => {
      addVariantImageMapEntry(map, {
        id: variant.id,
        title: variant.title,
        optionValues: variant.optionValues,
        image: variant.image,
        fallbackImage: product.image,
      });
    });

    return map;
  }

  function addVariantImageMapEntry(map, entry) {
    const image = normalizeImageUrl(entry.image || entry.fallbackImage || '');
    if (!isUsableImageUrl(image)) return;

    const value = {
      variantId: String(entry.id || ''),
      variantTitle: entry.title || '',
      optionValues: entry.optionValues || [],
      image,
      fallbackImage: normalizeImageUrl(entry.fallbackImage || ''),
    };

    if (value.variantId) map.byId.set(value.variantId, value);
    [value.variantTitle, ...value.optionValues].forEach((title) => {
      const key = normalizeOptionText(title);
      if (key && !map.byTitle.has(key)) map.byTitle.set(key, value);
    });
  }

  function updateBundleCardImage(image, imageUrl, altText) {
    if (!(image instanceof HTMLImageElement) || !isUsableImageUrl(imageUrl)) return false;

    const normalizedUrl = normalizeImageUrl(imageUrl);
    if (image.hasAttribute('srcset')) image.setAttribute('srcset', normalizedUrl);
    image.alt = altText || image.alt || '';

    if (image.getAttribute('src') !== normalizedUrl) {
      image.src = normalizedUrl;
    }

    return image.getAttribute('src') === normalizedUrl || image.src === normalizedUrl;
  }

  function buildVariantImageAlt(product, variant) {
    const title = [product?.title, variant?.title].filter(Boolean).join(' - ');
    return title || product?.title || variant?.title || '';
  }

  function isUsableImageUrl(url) {
    const normalizedUrl = normalizeImageUrl(url);
    if (!normalizedUrl) return false;
    if (/^(data:image\/|blob:|https?:\/\/|\/)/i.test(normalizedUrl)) return true;
    return normalizedUrl.startsWith(window.location.origin);
  }

  function getSelectedVariantIds() {
    return state.products.map((product) => product.selectedVariantId).filter(Boolean);
  }

  function formatVariantPrice(variant) {
    const price = getVariantPrice(variant);
    const formatted = price.formatted || (price.cents != null ? formatMoney(price.cents) : '');
    debug('final formatted price string', {
      variantId: variant?.id,
      formatted,
      source: price.source,
    });
    return formatted;
  }

  function getVariantPrice(variant) {
    if (!variant) return emptyPrice('missing');
    if (variant.price) return variant.price;
    return {
      cents: variant.priceCents ?? null,
      formatted: variant.priceText || '',
      raw: variant.priceText || variant.priceCents || '',
      source: variant.priceText ? 'legacy:formatted' : 'legacy:cents',
      kind: variant.priceText ? 'formatted' : 'cents',
    };
  }

  function formatMoney(cents) {
    if (typeof window.Shopify?.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, getMoneyFormat());
    }

    const currency = getCurrency();
    const precision = MONEY_DECIMALS[currency] ?? 2;
    const divisor = Math.pow(10, precision);
    const format = getMoneyFormat();
    const amount = (cents / divisor).toFixed(precision);
    const [whole, fraction = ''] = amount.split('.');
    const withCommas = whole.replace(/\d(?=(\d{3})+$)/g, '$&,');

    return format.replace(/{{\s*(\w+)\s*}}/g, (_, token) => {
      switch (token) {
        case 'amount':
          return precision > 0 ? `${withCommas}.${fraction}` : withCommas;
        case 'amount_no_decimals':
          return whole.replace(/\d(?=(\d{3})+$)/g, '$&,');
        case 'amount_with_comma_separator':
          return precision > 0 ? `${whole.replace(/\d(?=(\d{3})+$)/g, '$&.')},${fraction}` : whole;
        case 'amount_no_decimals_with_comma_separator':
          return whole.replace(/\d(?=(\d{3})+$)/g, '$&.');
        case 'amount_no_decimals_with_space_separator':
          return whole.replace(/\d(?=(\d{3})+$)/g, '$& ');
        case 'amount_with_space_separator':
          return precision > 0 ? `${whole.replace(/\d(?=(\d{3})+$)/g, '$& ')},${fraction}` : whole;
        case 'currency':
          return currency;
        default:
          return precision > 0 ? `${withCommas}.${fraction}` : withCommas;
      }
    });
  }

  function getMoneyFormat() {
    const config = window.oasisleepCustomSelleasyBundleConfig || {};
    return config.moneyFormat || config.moneyWithCurrencyFormat || '${{amount}}';
  }

  function getCurrency() {
    const config = window.oasisleepCustomSelleasyBundleConfig || {};
    return String(window.Shopify?.currency?.active || config.currency || '').toUpperCase();
  }

  function normalizePayloadPrice(value) {
    const formatted = value.priceText || value.formatted_price || value.formattedPrice || value.displayPrice || value.display_price;
    if (formatted) {
      return normalizePriceValue(formatted, {
        source: 'payload:formatted',
        preserveFormatted: true,
      });
    }

    const entries = [
      ['price_cents', value.price_cents],
      ['priceCents', value.priceCents],
      ['variantPriceCents', value.variantPriceCents],
      ['price', value.price],
      ['variant_price', value.variant_price],
      ['variantPrice', value.variantPrice],
      ['amount', value.amount],
    ];

    const entry = entries.find(([, raw]) => raw != null && raw !== '');
    if (!entry) return emptyPrice('payload:none');

    return normalizePriceValue(entry[1], {
      source: `payload:${entry[0]}`,
      key: entry[0],
    });
  }

  function normalizePriceValue(raw, options = {}) {
    const source = options.source || 'unknown';
    const key = options.key || '';
    const preserveFormatted = Boolean(options.preserveFormatted);

    if (raw == null || raw === '') return emptyPrice(source, raw);

    if (typeof raw === 'object') {
      return normalizePayloadPrice(raw);
    }

    const rawText = String(raw).trim();
    const formattedMoney = extractMoneyText(rawText);

    if (formattedMoney && (preserveFormatted || /[^\d.,\s-]/.test(rawText))) {
      const cents = parseFormattedMoneyToCents(formattedMoney);
      const price = {
        cents,
        formatted: preserveFormatted ? formattedMoney : cents != null ? formatMoney(cents) : formattedMoney,
        raw,
        source,
        kind: 'formatted',
      };
      logNormalizedPrice(price);
      return price;
    }

    const numericText = rawText.replace(/,/g, '');
    const numeric = typeof raw === 'number' ? raw : Number(numericText);
    if (!Number.isFinite(numeric)) {
      const price = {
        cents: formattedMoney ? parseFormattedMoneyToCents(formattedMoney) : null,
        formatted: preserveFormatted && formattedMoney ? formattedMoney : '',
        raw,
        source,
        kind: 'unparsed',
      };
      logNormalizedPrice(price);
      return price;
    }

    const keyLooksLikeCents = /cent|cents|minor|price_cents/i.test(key);
    const hasDecimal = String(raw).includes('.');
    const cents = keyLooksLikeCents || (!hasDecimal && Math.abs(numeric) >= 1000)
      ? Math.round(numeric)
      : decimalAmountToCents(numeric);

    const price = {
      cents,
      formatted: preserveFormatted && formattedMoney ? formattedMoney : '',
      raw,
      source,
      kind: keyLooksLikeCents || (!hasDecimal && Math.abs(numeric) >= 1000) ? 'cents-integer' : 'decimal-amount',
    };
    logNormalizedPrice(price);
    return price;
  }

  function emptyPrice(source, raw = '') {
    return {
      cents: null,
      formatted: '',
      raw,
      source,
      kind: 'empty',
    };
  }

  function mergePrice(primary, fallback) {
    if (primary?.formatted || primary?.cents != null) return primary;
    if (fallback?.formatted || fallback?.cents != null) return fallback;
    return primary || fallback || emptyPrice('missing');
  }

  function logNormalizedPrice(price) {
    debug('normalized price value', {
      source: price.source,
      raw: price.raw,
      cents: price.cents,
      formatted: price.formatted,
      kind: price.kind,
    });
  }

  function decimalAmountToCents(amount) {
    const precision = MONEY_DECIMALS[getCurrency()] ?? 2;
    return Math.round(amount * Math.pow(10, precision));
  }

  function parseFormattedMoneyToCents(text) {
    const money = extractMoneyText(text);
    if (!money) return null;

    const precision = MONEY_DECIMALS[getCurrency()] ?? 2;
    const cleaned = money.replace(/[^\d.,'-]/g, '').replace(/'/g, '').trim();
    if (!cleaned) return null;

    const lastDot = cleaned.lastIndexOf('.');
    const lastComma = cleaned.lastIndexOf(',');
    const decimalIndex = Math.max(lastDot, lastComma);
    let whole = cleaned;
    let fraction = '';

    if (precision > 0 && decimalIndex > -1 && cleaned.length - decimalIndex - 1 <= precision) {
      whole = cleaned.slice(0, decimalIndex);
      fraction = cleaned.slice(decimalIndex + 1);
    }

    const wholeDigits = whole.replace(/[^\d-]/g, '') || '0';
    const fractionDigits = fraction.replace(/\D/g, '').padEnd(precision, '0').slice(0, precision);
    const sign = wholeDigits.startsWith('-') ? -1 : 1;
    const wholeValue = Math.abs(Number(wholeDigits));
    if (!Number.isFinite(wholeValue)) return null;

    return sign * (wholeValue * Math.pow(10, precision) + Number(fractionDigits || 0));
  }

  function extractMoneyText(text) {
    const raw = String(text || '').replace(/\s+/g, ' ').trim();
    if (!raw) return '';

    const currencyPattern = '[$€£¥₹₩₫₱฿₭៛]|\\b[A-Z]{3}\\b';
    const withCurrency = raw.match(
      new RegExp(
        `(?:(?:${currencyPattern})\\s*){1,2}[-+]?\\d[\\d\\s.,']*(?:\\s*(?:${currencyPattern})){0,2}|[-+]?\\d[\\d\\s.,']*(?:\\s*(?:${currencyPattern})){1,2}`
      )
    );
    if (withCurrency) return withCurrency[0].trim();

    const decimalNumber = raw.match(/[-+]?\d[\d\s,']*[.,]\d{1,4}/);
    if (decimalNumber) return decimalNumber[0].trim();

    const integerNumber = raw.match(/[-+]?\d[\d\s,']*/);
    return integerNumber ? integerNumber[0].trim() : '';
  }

  function stripMoneyFromText(text) {
    const money = extractMoneyText(text);
    return String(text || '')
      .replace(money, '')
      .replace(/\s*[-–—:|]\s*$/, '')
      .trim();
  }

  function extractDiscountPercent(widget, payloads, totals) {
    const payloadDiscount = findPayloadNumber(payloads, [
      'discountPercentage',
      'discount_percent',
      'discountPercent',
      'discount_percentage',
      'discountText',
      'discount_text',
      'discountLabel',
      'discount_label',
      'discountValue',
      'discount_value',
      'percentage',
      'discount',
    ]);

    const normalizedPayloadDiscount = normalizeDiscountPercent(payloadDiscount);
    if (isValidDiscountPercent(normalizedPayloadDiscount)) {
      return {
        percent: normalizedPayloadDiscount,
        source: 'payload',
      };
    }

    const datasetText = JSON.stringify(getPlainDataset(widget));
    const datasetMatch = datasetText.match(/(?:discount|percentage|percent)[^0-9]{0,24}(\d+(?:\.\d+)?)\s*%?/i);
    if (datasetMatch && isValidDiscountPercent(Number(datasetMatch[1]))) {
      return {
        percent: Number(datasetMatch[1]),
        source: 'dataset',
      };
    }

    const textMatch = widget.textContent.match(/(?:save|discount|off)[^0-9]{0,24}(\d+(?:\.\d+)?)\s*%|(\d+(?:\.\d+)?)\s*%\s*(?:off|discount|save)/i);
    const textPercent = textMatch ? Number(textMatch[1] || textMatch[2]) : null;
    if (isValidDiscountPercent(textPercent)) {
      return {
        percent: textPercent,
        source: 'widget-text',
      };
    }

    if (totals.originalCents && totals.discountedCents && totals.discountedCents < totals.originalCents) {
      const calculated = ((totals.originalCents - totals.discountedCents) / totals.originalCents) * 100;
      if (isValidDiscountPercent(calculated)) {
        return {
          percent: calculated,
          source: 'calculated-from-totals',
        };
      }
    }

    return {
      percent: null,
      source: 'unavailable',
    };
  }

  function isValidDiscountPercent(value) {
    const numeric = Number(value);
    return Number.isFinite(numeric) && numeric > 0 && numeric <= 100;
  }

  function normalizeDiscountPercent(value) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric) || numeric <= 0) return null;
    return numeric <= 1 ? numeric * 100 : numeric;
  }

  function getEffectiveDiscountPercent() {
    return isValidDiscountPercent(state.discountPercent) ? Number(state.discountPercent) : null;
  }

  function extractWidgetTotals(widget) {
    const totalNodes = Array.from(widget.querySelectorAll('[class*="total" i], [class*="subtotal" i], [class*="price" i], [data-total], [data-price]'))
      .filter((node) => node instanceof HTMLElement)
      .map((node) => node.textContent.trim().replace(/\s+/g, ' '))
      .filter((text) => text && text.length < 100);

    const prices = totalNodes
      .map((text) => normalizePriceValue(extractMoneyText(text), { source: 'widget-total', preserveFormatted: true }))
      .filter((price) => price.cents != null)
      .map((price) => price.cents);

    if (prices.length < 2) return {};

    return {
      originalCents: Math.max(...prices),
      discountedCents: Math.min(...prices),
    };
  }

  function getControlVariantId(control) {
    if (!(control instanceof HTMLElement)) return '';
    if (control instanceof HTMLSelectElement) return control.value;
    if (control instanceof HTMLInputElement) return control.dataset.variantId || control.value || '';
    return control.getAttribute('data-variant-id') || control.getAttribute('value') || '';
  }

  function dispatchNativeChange(control) {
    control.dispatchEvent(new Event('input', { bubbles: true }));
    control.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getControlText(control) {
    if (!(control instanceof HTMLElement)) return '';
    return (
      control.textContent ||
      control.getAttribute('aria-label') ||
      control.getAttribute('value') ||
      control.getAttribute('title') ||
      ''
    ).trim();
  }

  function getLabelText(input) {
    if (!(input instanceof HTMLInputElement)) return '';
    if (input.id) {
      const escapedId = window.CSS?.escape ? window.CSS.escape(input.id) : input.id.replace(/"/g, '\\"');
      const label = document.querySelector(`label[for="${escapedId}"]`);
      if (label) return label.textContent.trim();
    }
    return input.closest('label')?.textContent.trim() || '';
  }

  function firstDatasetEntry(node, keys) {
    if (!(node instanceof HTMLElement)) return null;

    for (const key of keys) {
      if (node.dataset[key]) {
        return {
          key,
          value: node.dataset[key],
        };
      }

      const attrName = `data-${key.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`)}`;
      const attr = node.getAttribute(attrName);
      if (attr) {
        return {
          key,
          value: attr,
        };
      }
    }

    return null;
  }

  function firstDatasetValue(node, keys) {
    return firstDatasetEntry(node, keys)?.value || '';
  }

  function getPlainDataset(node) {
    if (!(node instanceof HTMLElement)) return {};
    return Object.assign({}, node.dataset);
  }

  function looksLikePrice(text) {
    const value = String(text || '');
    const hasCurrency = /[$€£¥₹₩₫₱฿₭៛]|\b[A-Z]{3}\b/.test(value);
    if (!hasCurrency && /%/.test(value)) return false;
    return /([$€£¥₹₩₫₱฿₭៛]|\b[A-Z]{3}\b)?\s*\d[\d\s.,']*/.test(value);
  }

  function normalizeOptionText(text) {
    return stripMoneyFromText(text)
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace(/[^\w\s-]/g, '')
      .trim();
  }

  function handleize(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    if (url.startsWith('//')) return `https:${url}`;
    return url;
  }

  function dedupeProducts(products) {
    const seen = new Set();
    return products.filter((product) => {
      const key = product.title || product.selectedVariantId || product.image;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  function dedupeVariants(variants) {
    const seen = new Set();
    return variants.filter((variant) => {
      if (seen.has(variant.id)) return false;
      seen.add(variant.id);
      return true;
    });
  }

  function dedupeElements(elements) {
    const output = [];
    elements.forEach((element) => {
      if (output.some((item) => item === element || item.contains(element) || element.contains(item))) return;
      output.push(element);
    });
    return output;
  }

  function setText(root, selector, text) {
    const node = root.querySelector(selector);
    if (node) node.textContent = text || '';
  }

  function formatPercent(value) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric) || numeric <= 0) return '';
    return `${numeric % 1 ? numeric.toFixed(1).replace(/\.0$/, '') : Math.round(numeric)}%`;
  }

  function isDebug() {
    try {
      return window.localStorage.getItem(DEBUG_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function debug(label, ...values) {
    if (!isDebug()) return;
    console.log(`[custom Selleasy bundle] ${label}`, ...values);
  }
})();
